import { createFileRoute } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";
import { DefectsPage } from "@/sections/defects/page";

function DefectsRoute() {
  return <DefectsPage />;
}

export const Route = createFileRoute("/dashboard/defects/")({
  component: DefectsRoute,
  beforeLoad: ({ context }) => {
    // Viewer floor — viewers get read-only access to the defects list and
    // detail (the defect-svc list/get endpoints have no role floor; writes
    // are gated server-side at inspector/manager). Mutating controls are
    // gated within the pages.
    requireMinRole(context.session, "viewer");
  },
  staticData: {
    title: "Defects",
  },
});
